import { render } from "./CardItem.vue?vue&type=template&id=56f16cb8&scoped=true"
import script from "./CardItem.vue?vue&type=script&lang=js"
export * from "./CardItem.vue?vue&type=script&lang=js"

import "./CardItem.vue?vue&type=style&index=0&id=56f16cb8&scoped=true&lang=css"
import "./CardItem.vue?vue&type=style&index=1&id=56f16cb8&lang=css"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f16cb8"]])

export default __exports__